<section fxLayout="row" fxLayoutAlign="space-between center">
  <h2 class="truncate">Notifications</h2>
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</section>

<mat-dialog-content class="notifications-dialog">
  <ng-container *ngIf="isLoading">
    <div class="loading-container">
      <hospitable-loading></hospitable-loading>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading">
    <!-- Action Required Section -->
    <div class="notification-section">
      <ng-container *ngFor="let group of actionRequiredGroups">
        <div class="notification-group">
          <a [href]="group.notifications[0].cta_url" target="_blank" class="notification-item">
            <div class="header-content">
              <div>
                <span class="title">{{ group.title }}</span>
                <span class="subtitle">{{ group.notifications[0].subtitle }}</span>
              </div>
            </div>
          </a>
        </div>
      </ng-container>
    </div>

    <mat-divider *ngIf="actionRequiredGroups.length > 0 && listingIssueGroups.length > 0"></mat-divider>

    <!-- Listing Issues Section -->
    <div class="notification-section" *ngIf="listingIssueGroups.length > 0">
      <div *ngFor="let group of listingIssueGroups" class="notification-group">
        <div class="notification-header expandable" (click)="group.isExpanded = !group.isExpanded">
          <div class="notification-item">
            <div class="header-content">
              <span class="title">{{ group.title }} ({{ group.notifications.length }})</span>
              <mat-icon class="expand-icon" [class.expanded]="group.isExpanded">
                chevron_right
              </mat-icon>
            </div>
          </div>
        </div>
        <div class="notification-items" *ngIf="group.isExpanded">
          <ng-container *ngFor="let notification of group.notifications">
            <a [href]="notification.cta_url" target="_blank" class="notification-item listing-item">
              <div class="header-content">
                <span class="listing-name">{{ notification.description || notification.subtitle }}</span>
                <span class="review-link">Review issues</span>
              </div>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>
